import MaterialIcon from "material-icons-react";
import { Spinner } from "react-bootstrap";
// import NumberFormat from "react-number-format";
import Drawer from "../../../../../components/Drawer";
import xIconBlack from "../../../../../assets/img/x-icon-black.svg";
import { useHistory } from "react-router-dom";
import api from "../../../../../config/api";
import { Panel, PanelGroup } from "rsuite";
import DisabledTextField from "../../../../../components/inputs/DisabledTextField";
import DisabledMultiLineTextField from "../../../../../components/inputs/DisabledTextField/DisabledMultiLineTextField";

const ReserveRecreationDrawer = ({
  openDrawer,
  setShowProduct,
  showProduct,
  setOpenDrawer,
  isRecreationDrawerOpen,
  loadBtn,
  product,
  viewReserve,
  showExtras,
  setShowExtras,
  addNew,
}) => {
  const history = useHistory();
  const openChat = async (e) => {
    e.preventDefault();
    let object = {
      user: viewReserve?.user?._id,
      establishment: viewReserve?.establishment,
      to: viewReserve?.user?._id,
      from: viewReserve?.establishment?.user,
    };
    const response = await api.post("/chat/", object).then((resp) => {
      console.log(resp);
      return history.push("/chat/" + resp.data.chat._id);
    });
  };
  return (
    <Drawer show={isRecreationDrawerOpen} onClose={() => setOpenDrawer(false)} onOpen={() => setOpenDrawer(true)}>
      <form style={{ maxHeight: "100%" }}>
        <div className="d-flex col align-items-center">
          <span className="text-cl-black ff-univanova-medium fz-20 mb-4 mt-3  me-auto">Informações do agendamento</span>
        </div>
        <div className="d-flex flex-column">
          <DisabledTextField
            label={"Cliente"}
            variant={"outlined"}
            value={viewReserve?.user?.name}
            // style={{ width: "70%" }}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          />
          <DisabledTextField
            label={"Data"}
            variant={"outlined"}
            value={viewReserve?.date}
            // type={"date"}
            // style={{ width: "70%" }}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          />
          <DisabledTextField
            label={"Hora"}
            value={viewReserve?.time}
            // type={"time"}
            variant={"outlined"}
            // style={{ width: "70%" }}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          />
          {/* <DisabledTextField
            label={"Número de pessoas"}
            variant={"outlined"}
            value={viewReserve?.qtyClients}
            // style={{ width: "70%" }}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          /> */}
          <DisabledMultiLineTextField
            label={"Observação geral"}
            variant={"outlined"}
            multiline
            minRows={4}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          />

          <span className="text-cl-black ff-univanova-medium fz-20 mb-4 d-block">Produtos agendados</span>
          {viewReserve.products?.length ? (
            <>
              {viewReserve.products.map((product, index) => (
                <>
                  <PanelGroup accordion className="mt-1">
                    <Panel
                      bodyFill={false}
                      className={`${
                        viewReserve.status === "Cancelada"
                          ? "bg-cl-red"
                          : product.payed
                          ? "bg-cl-forest-green"
                          : "bg-cl-american-orange "
                      } `}
                      header={
                        <div className="text-white ff-univanova-600 fz-16 d-flex align-items-center">
                          <span className="me-auto">
                            {product.product.name} {product.qtyProduct > 0 ? `(${product.qtyProduct})` : ""} -{" "}
                            {viewReserve.status === "Cancelada"
                              ? viewReserve.status === "Cancelada" && product.payed
                                ? "Valor extornado"
                                : "Reserva cancelada"
                              : product.payed
                              ? "Pago"
                              : "Pgto. Pendente"}
                          </span>
                          <div className="d-flex align-items-center">
                            <MaterialIcon color="white" icon="expand_more" />
                          </div>
                        </div>
                      }
                      eventKey={product?._id}
                      id={product?._id}
                    >
                      <div className=" bg-white p-3 d-flex flex-column p-3 px-4 pt-4 ">
                        <DisabledTextField
                          label={"Nome do produto"}
                          variant={"outlined"}
                          value={product.product.name}
                          className="fz-16 text-cl-dark-jungle-green ff-univanova mb-3"
                        />
                        <DisabledTextField
                          label={"Quantidade"}
                          variant={"outlined"}
                          value={product.qtyProduct}
                          className="fz-16 text-cl-dark-jungle-green ff-univanova mb-3"
                        />

                        <DisabledMultiLineTextField
                          label={"Observações do Cliente"}
                          variant={"outlined"}
                          value={product.description || ""}
                          multiline
                          minRows={4}
                          className="fz-16 text-cl-dark-jungle-green ff-univanova mb-3"
                          InputProps={{
                            rows: 4,
                          }}
                        />
                      </div>
                    </Panel>
                  </PanelGroup>
                </>
              ))}
            </>
          ) : (
            <div className="border-top border-bottom p-3 d-flex mt-4 justify-content-center">
              <span className="text-cl-auroMetal ff-univanova-medium fz-16 ">Nenhum produto encontrado</span>
            </div>
          )}
          {viewReserve.extraProduct?.length ? (
            <>
              {viewReserve.extraProduct.map((product, index) => (
                <>
                  <PanelGroup accordion className="mt-1">
                    <Panel
                      bodyFill={false}
                      className={`${
                        viewReserve.status === "Cancelada"
                          ? "bg-cl-red"
                          : product.payed
                          ? "bg-cl-forest-green"
                          : "bg-cl-american-orange "
                      } `}
                      header={
                        <div className="text-white ff-univanova-600 fz-16 d-flex align-items-center">
                          <span className="me-auto">
                            Serviços extras{" "}
                            {viewReserve.status === "Cancelada"
                              ? viewReserve.status === "Cancelada" && product.payed
                                ? "Valor extornado"
                                : "Reserva cancelada"
                              : product.payed
                              ? "Pago"
                              : "Pgto. Pendente"}
                          </span>
                          <div className="d-flex align-items-center">
                            <MaterialIcon color="white" icon="expand_more" />
                          </div>
                        </div>
                      }
                      eventKey={product?._id}
                      id={product?._id}
                    >
                      <div
                        className="d-flex flex-column bg-white p-3 px-4 pt-4  "
                        style={{ border: "1px solid #D9D9D9" }}
                      >
                        <DisabledTextField
                          label={"Nome do produto"}
                          variant={"outlined"}
                          value={product.name}
                          className="fz-16 text-cl-dark-jungle-green ff-univanova mb-3"
                        />
                      </div>
                    </Panel>
                  </PanelGroup>
                </>
              ))}
            </>
          ) : (
            <></>
          )}

          <span className="text-cl-black ff-univanova-medium fz-20 mb-4 d-block mt-4">Informações de contato</span>
          <DisabledTextField
            label={"E-mail"}
            variant={"outlined"}
            value={viewReserve?.user?.email}
            type={"email"}
            // style={{ width: "70%" }}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          />
          <DisabledTextField
            label={"Telefone"}
            variant={"outlined"}
            type={"tel"}
            value={viewReserve?.user?.phone}
            // style={{ width: "70%" }}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-2"
          />
          <div className={`ms-auto col-lg-auto  d-flex justify-content-end mb-4 mt-lg-2 `}>
            <button
              onClick={(e) => {
                openChat(e);
              }}
              className="w-100 button-add btn bg-gradient-theme-blue text-white fz-14 px-4 py-2 d-flex justify-content-center align-items-center ff-univanova-medium"
            >
              Enviar menssagem
            </button>
          </div>

          <div className="border-top border-bottom p-3 d-flex mt-4">
            <span className="text-cl-black ff-univanova-medium fz-20 d-block justify-content-start me-auto">
              Valor Total
            </span>
            <span className="text-cl-forest-green ff-univanova-medium fz-20 d-block justify-content-end">
              R${" "}
              {parseFloat(viewReserve.totalPrice).toFixed(2) === "NaN"
                ? "--,--"
                : parseFloat(viewReserve.totalPrice).toFixed(2)}
            </span>
          </div>
          {product?._id ? (
            <div className={`col-12 col-lg d-flex justify-content-end mt-5`}>
              <button
                onClick={(e) => setOpenDrawer(false)}
                className="bg-transparent border-1 me-4 rounded-2 fz-14 d-flex justify-content-center align-items-center ff-univanova-medium py-2 px-4 botton-cancel"
              >
                Cancelar
              </button>
              <button
                onClick={(e) => console.log(e)}
                className="btn bg-gradient-theme-blue text-white rounded-2 fz-14 d-flex justify-content-center align-items-center ff-univanova-medium py-2 px-4"
              >
                {loadBtn ? (
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                ) : product?._id ? (
                  "Salvar"
                ) : (
                  "Adicionar"
                )}
              </button>
            </div>
          ) : (
            <></>
          )}
        </div>
      </form>
    </Drawer>
  );
};

export default ReserveRecreationDrawer;
